<template>
    <div>
        <div class="has-text-white">
            Teamforce is currently in alpha development.
            Want to join our early access program? Enter your email here:
        </div><br/>

        <base-backend-errors :data="create.error"/>

        <div v-if="success" class="notification is-info">
            You are successfully subscribed!
        </div>

        <base-input
            v-model="form.email"
            name="email"
            icon="fas fa-envelope"
            validate="required|email"
            placeholder="Email"/>

        <base-button
            @click="subscribe"
            class="is-primary is-fullwidth"
            text="Request early access"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Subscribe',
    computed: mapState('subscribers', ['create']),
    data() {
        return {
            form: { email: null },
            success: false,
        };
    },
    methods: {
        subscribe() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$store.dispatch('subscribers/create', this.form).then(() => {
                    this.success = true;
                    this.form.email = null;
                });
            });
        },
    },
};
</script>

<style scoped>

</style>
